/** TODO: Delete when migrating apply */
import { Button, CircularProgress } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import React from 'react';

const ButtonPrimary = ({
  isLoading, children, variant, onClick,
}) => (
  <Button
    type="submit"
    fullWidth
    onClick={onClick}
    variant={variant}
    disabled={isLoading}
    startIcon={isLoading ? <CircularProgress size={18} sx={{ color: 'info.main' }} /> : variant !== 'text' && <LockIcon size={18} />}
  >
    {children}
  </Button>
);

export default ButtonPrimary;
